import styled from "styled-components";
import {hexToRgb} from "../../../utils/editorUtils";
export const NodeStyle = styled.div(({ theme, isSelected }) => ({
  ...theme,
  ...shadowBox(isSelected,theme.backgroundColor)
}));
//creates a shadow when the node is selected
const shadowBox = (isSelected, backgroundColor) => {
  const { r, g, b } = hexToRgb(backgroundColor);
  const color = `rgba(${r},${g},${b},0.78)`;
  return isSelected
    ? { boxShadow: `0 10px 20px ${color}`, marginTop: "-2px" }
    : {};
};
